<template>
  <div
    :class="['drawer-section-header', { 'drawer-section-header--alert': alert, 'drawer-section-header--clickable': collapsible }]"
    :role="collapsible ? 'button' : undefined"
    :tabindex="collapsible ? 0 : undefined"
    @click="onClick"
    @keydown.enter="onClick"
    @keydown.space.prevent="onClick"
  >
    <span class="drawer-section-header__label">
      {{ label }}
      <span v-if="count != null" class="drawer-section-header__count">({{ count }})</span>
    </span>
    <!-- Slot opcional para un botón de acción a la derecha (ej. "+ Agregar"
         en la sección Notas del incidente). Se renderiza antes del chevron
         para no estorbar la zona clickable del collapsible. -->
    <slot name="action" />
    <v-icon
      v-if="collapsible"
      x-small
      class="drawer-section-header__chevron"
    >{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
  </div>
</template>

<script>
// Subheader de sección del drawer según DRAWERS-DESIGN-SPEC §8.2.
// Uppercase, 11px, letter-spacing 0.06em, peso 600, color text-muted.
// Variante --alert para secciones con información operativa crítica
// (mandamientos, eventos activos, hits recientes, etc.).
export default {
  name: 'DrawerSectionHeader',
  props: {
    label: { type: String, required: true },
    count: { type: [Number, String], default: null },
    alert: { type: Boolean, default: false },
    collapsible: { type: Boolean, default: false },
    expanded: { type: Boolean, default: true },
  },
  methods: {
    onClick() {
      if (this.collapsible) this.$emit('toggle')
    },
  },
}
</script>

<style scoped>
.drawer-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 6px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--kln-text-muted, rgba(255, 255, 255, 0.55));
  user-select: none;
  transition: color 0.15s;
}

/* Label empuja el resto a la derecha con margin-left: auto.
   Eso agrupa el slot #action y el chevron juntos al borde derecho. */
.drawer-section-header__label {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  margin-right: auto;
}

.drawer-section-header__count {
  font-weight: 500;
  color: var(--kln-text-dim, rgba(255, 255, 255, 0.35));
}

.drawer-section-header__chevron {
  color: var(--kln-text-muted, rgba(255, 255, 255, 0.55)) !important;
}

.drawer-section-header--alert {
  color: var(--kln-alert-danger);
  border-top: 2px solid var(--kln-alert-danger);
}

.drawer-section-header--alert .drawer-section-header__count {
  color: var(--kln-alert-danger);
  opacity: 0.75;
}

.drawer-section-header--clickable {
  cursor: pointer;
}

.drawer-section-header--clickable:hover {
  color: var(--kln-accent);
}

.drawer-section-header--clickable:hover .drawer-section-header__chevron {
  color: var(--kln-accent) !important;
}
</style>
